import { render, staticRenderFns } from "./Kb4.vue?vue&type=template&id=b492bce8&scoped=true&"
import script from "./Kb4.vue?vue&type=script&lang=js&"
export * from "./Kb4.vue?vue&type=script&lang=js&"
import style0 from "./Kb4.vue?vue&type=style&index=0&id=b492bce8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b492bce8",
  null
  
)

export default component.exports